import React from "react";

function Carrier() {
  return (
    <div className="card text-center" >
      <div className="card-header"><marquee><b>| Making sure your valuables are transported easily and hassle-free |</b></marquee></div>
      <div className="card-body bg-secondary">
        <h5 className="card-title">Source Code</h5>
        <p className="card-text">Read the source code of the project on GitHub.</p>
        <a href="https://github.com/yash18082002/MinorProject" className="btn btn-primary">Go There</a>
      </div>
    </div>)
}

export default Carrier;